import React from 'react';
import { motion } from 'framer-motion';
import { Check, BookOpen, Calendar, ShoppingCart, Coffee, BarChart2, LifeBuoy } from 'lucide-react';
export function BenefitsSection() {
  const changes = ['Menos hinchazón diaria', 'Energía más estable', 'Menos urgencia por azúcar en la noche', 'Más control sin obsesión', 'Ropa que vuelve a sentirse “tuya”'];
  const includes = [{
    icon: BookOpen,
    text: 'Guía completa del método A.I.R.'
  }, {
    icon: Calendar,
    text: 'Plan de 21 días con plantillas repetibles'
  }, {
    icon: ShoppingCart,
    text: 'Lista de compras maestra (Latina + Americana simple)'
  }, {
    icon: Coffee,
    text: 'Comidas “seguras” para no pensar tanto'
  }, {
    icon: Coffee,
    text: 'Snacks puente (para evitar el rebote)'
  }, {
    icon: BarChart2,
    text: 'Tracker diario (sueño, hinchazón, energía, antojos)'
  }, {
    icon: LifeBuoy,
    text: 'Manual de emergencia 48 horas (para volver sin drama)'
  }];
  return <section className="w-full bg-cream py-20 px-4 md:px-6" data-id="element-18">
      <div className="max-w-6xl mx-auto" data-id="element-19">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start" data-id="element-20">
          {/* Left Column: Results */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-21">
            <h2 className="text-3xl font-bold text-warm-dark mb-8 font-serif" data-id="element-22">
              Lo que cambia en 21 días <br data-id="element-23" />
              <span className="text-teal text-xl font-sans font-normal" data-id="element-24">
                (sin promesas irreales)
              </span>
            </h2>

            <ul className="space-y-6" data-id="element-25">
              {changes.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-center gap-4" data-id="element-26">
                  <div className="bg-teal text-white p-1 rounded-full flex-shrink-0" data-id="element-27">
                    <Check size={16} strokeWidth={3} data-id="element-28" />
                  </div>
                  <span className="text-xl text-warm-dark" data-id="element-29">{item}</span>
                </motion.li>)}
            </ul>
          </motion.div>

          {/* Right Column: What's Included */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 md:p-10 rounded-3xl shadow-lg border border-cream-dark/10" data-id="element-30">
            <h3 className="text-2xl font-bold text-warm-dark mb-8 text-center border-b border-cream pb-4" data-id="element-31">
              Qué incluye (exacto)
            </h3>

            <div className="space-y-5" data-id="element-32">
              {includes.map((item, index) => <div key={index} className="flex items-start gap-4" data-id="element-33">
                  <item.icon className="text-gold shrink-0 mt-1" size={20} data-id="element-34" />
                  <span className="text-warm-gray text-lg" data-id="element-35">{item.text}</span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}